import { domainRegExp } from 'utils/validations/domain'

const DEFAULT_MULTI_DOMAIN_MESSAGE =
  'One of the entered domains is either an invalid domain or contains a missing comma.'

const EMPTY_DOMAIN_MESSAGE = 'Please note that you have selected to delete all permitted domains'

const multiDomain = (value) => {
  if (!value) return EMPTY_DOMAIN_MESSAGE
  if (value) {
    const parsedValue = value.replace(/\s*,\s*/g, ',').replace(/\s+$/g, '')
    const domains = parsedValue.split(',')
    const isValid = domains.every((domain) => domainRegExp.test(domain))

    if (!isValid) {
      return DEFAULT_MULTI_DOMAIN_MESSAGE
    }
    return undefined
  }
  return undefined
}

export default multiDomain
